<template>
  <div class="main-container">
    <div style="width: 100%;">
      <div class="table-header-custom">
        <el-input
          style="max-width: 400px"
          placeholder="Type something"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
        ></el-input>
      </div>
      <vue-good-table
        :columns="fields"
        :rows="getUsers"
        :search-options="{enabled: true, 
        searchFn: searchTable,
                externalQuery: searchTerm}"
        :pagination-options="{enabled: true}"
      >
        <template
          slot="table-row"
          slot-scope="props"
          style="background: red;"
          @click.stop="navTo(details[0],props.row.id)"
        >
          <!-- {{1}} -->
          <span
            v-if="props.column.field == 'full_name'"
          >{{ props.row.firstName }} {{ props.row.lastName }}</span>
          <span
            v-if="props.column.field == 'gender'"
          >{{(props.row.gender+"" === "0")?'Female':'Male'}}</span>
          <span v-else-if="props.column.field == 'actions'">
            <b-button-group>
              <!-- <b-button variant="success" @click.stop="navTo(details[1],props.row.id)">Role</b-button> -->
              <b-button
                variant="outline-primary"
                @click.stop="navTo(details[0],props.row.id)"
              >Details</b-button>
            </b-button-group>
          </span>
          <span v-else>{{props.row[props.column.field]}}</span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import moment from "moment";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  name: "invoices",
  components: {
    // "vk-offcanvas": Offcanvas,
    // "vk-offcanvas-close": OffcanvasClose
  },
  data() {
    return {
      links: [],
      state: "",
      timeout: null,
      showOffCanvas: false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [
        {
          field: "id",
          label: "ID",
          sortable: "true"
        },
        {
          field: "full_name",
          label: "Full Name",
          sortable: "true"
        },
        {
          field: "roleType",
          label: "User Type",
          sortable: "true"
        },
        {
          field: "email",
          label: "E-mail",
          sortable: "true"
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: "gender",
          label: "Gender",
          sortable: "true"
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: "phoneNumber",
          label: "Phone Number",
          sortable: "true"
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: "updatedAt",
          label: "Last Seen",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Actions"
        }
      ],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices"
    ]),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/users?filter[include][installations]=deviceType&filter[where][roleType]=CUSTOMER`+`&filter[order]=id DESC`;
      HTTP.get(url)
        .then(response => {
          const usersList = response.data;
          this.$store.commit("saveUsers", usersList);
          // console.log(this.getUserById(1))
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  mounted() {
    this.fetchUsers();
    // this.links = this.loadAll();
    // console.log(this.getDummy)
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}

.form-item {
  display: flex;
  flex-flow: column;
  padding: 10px 0;
}
.customer-btn {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/invoices.vue